import Filters from '@wwdev/product/filters';
import SearchRequest from '@wwdev/product/SearchRequest';

class CustomFilters extends Filters {
	constructor(config) {
		super(Object.assign({
			types: '[data-scope="types"]',
		}, config));
	}

	initEventListeners() {
		super.initEventListeners();
		$(this.config.filters).on('click.product', '[data-remove-filter]', this.removeFilter.bind(this))
		$(this.config.types).off('.product')
			.on('click.product', '[data-filter]', this.handleFilterClick.bind(this))
		this.openMobileFilters();
		this.closeMobileFilters();
		this.toggleFilters();
	}

	removeFilter(e) {
		e.preventDefault();
		let $button = $(e.currentTarget);
		this._removeFilter($button.data('tree-id'), $button.data('remove-filter'));
	}

	_removeFilter(treeId, filterId) {
		SearchRequest.clearFilter(treeId, filterId);
		this.reload();
	}

	handleResponse(response) {
		$(this.config.types).html(response.types);

		super.handleResponse(response);
	}

	beforeCallback() {
		super.beforeCallback();
		// show loader
		jQuery('#spinner').removeClass('d-none');
	}

	afterCallback() {
		super.afterCallback();
		// hide loader
		jQuery('#spinner').addClass('d-none');
	}

	openMobileFilters() {
		$('.open-filters').on('click', () => {
			$('body').addClass('filters-open');
		});
	}
	toggleFilters() {
		$('.show_more_filters').on('click', (e) => {
			let $button = $(e.currentTarget);
			$button.parent('.collapse').find('.default-hided').toggleClass('d-none');
			if (!$button.hasClass('open')) {
				$button.text('Minder filters');
				$button.addClass('open');
			} else {
				$button.text('Meer filters');
				$button.removeClass('open');
			}
		});
	}
	closeMobileFilters() {
		$('.close-filters').on('click', () => {
			$('.body').removeClass('filters-open');
		});
	}
}

export default CustomFilters;